<template>
  <div class="player-menu-open account">
    <h2 v-if="!emailSent" class="title is-4">Having fun? Host your own 🎉</h2>
    <ul v-if="!emailSent" class="m-b-30">
      <li>🍻 Virtual happy hour</li>
      <li>🎲 Icebreaker games</li>
      <li>❔ Group trivia night</li>
      <li>🙋‍♀️ Live polls &amp; quizzes</li>
    </ul>
    <template v-else>
      <p class="title is-4">{{ inviteFriend ? `Spread the fun 🙌` : `Your invitation has been sent! 🎉` }}</p>
      <p v-if="!shareEmailSent" class="m-b-30">Would you like to invite a friend or coworker?</p>
      <p v-else class="m-b-30">Would you like to invite another friend or coworker?</p>
      <b-field>
        <b-input
          :expanded="true"
          v-model="name"
          placeholder="Name"
          icon-pack="fas"
          icon="envelope"
          size="is-medium"
          type="text"
          class="is-fullwidth"
        />
      </b-field>
    </template>
    <b-field>
      <b-input
        :expanded="true"
        v-model="email"
        @input="checkEmailSpelling()"
        :placeholder="emailSent ? `Email` : `Your email`"
        icon-pack="fas"
        icon="envelope"
        size="is-medium"
        type="text"
        class="is-fullwidth"
      />
      <span v-if="suggestion" @click="setSuggestedEmail()" class="suggestion">do you mean <u>{{ suggestion }}</u>?</span>
    </b-field>
    <button @click="startSendInvite($event)" class="button is-primary is-medium is-fullwidth">{{ emailSent ? 'Send invitation' : 'Send me an invite' }}</button>
    <p class="is-small">We'll only send <em>a single email</em> and won't share your address.</p>
    <button v-if="!inviteFriend && !emailSent" @click="inviteFriend = true; emailSent = true" class="button is-primary is-outlined is-fullwidth m-t-30">Invite a friend</button>
  </div>
</template>

<script>
import emailSpellChecker from '@zootools/email-spell-checker'
import { validateEmail } from '../common/functions'

export default {
  data () {
    return {
      email: '',
      sugestion: null,
      inviteFriend: false,
      emailSent: false,
      name: '',
      shareEmailSent: false
    }
  },
  computed: {
    activeEvent () {
      return this.$store.state.activeEvent
    },
    posthogProps () {
      return {
        event_id: this.activeEvent.id,
        shortcode: this.activeEvent.shortcode,
        player_id: this.activeEvent.player?.id,
        host_id: this.$parent?.eventMeta?.primaryUser,
        friend_email: this.email
      }
    }
  },
  methods: {
    checkEmailSpelling () {
      const suggestion = emailSpellChecker.run({ email: this.email })
      if (suggestion) {
        this.suggestion = suggestion.full
      } else {
        this.suggestion = null
      }
    },
    setSuggestedEmail () {
      this.email = this.suggestion
      this.suggestion = null
    },
    async startSendInvite (event) {
      event.target.classList.add('is-loading')

      const validation = await validateEmail(this.email)
      if (validation.isValid === false) {
        this.throwError(`Error sending this email, please check and try again!`)
        event.target.classList.remove('is-loading')
        return
      }

      this.posthogCapture('player:friend_invite', this.posthogProps)

      const email = {
        to: this.email,
        templateId: 20768166,
        variables: {
          firstName: this.name
        },
        tag: 'player-friend-invite'
      }

      try {
        await this.$axios.post(process.env.SITE_URL + '/api/send-email-template', email)
        // console.log(resp)
      } catch (e) {
        this.throwError(e.message)
        event.target.classList.remove('is-loading')
      }

      this.email = ''
      this.name = ''

      event.target.classList.remove('is-loading')
      if (this.emailSent) {
        this.shareEmailSent = true
        this.$buefy.toast.open({ type: 'is-success', message: 'Invitation sent!' })
      } else {
        this.emailSent = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.suggestion {
  display: block;
  background-color: rgb(243, 230, 153);
  color: #444;
  padding: 8px 16px;
  border-radius: 8px;
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 24px;
}

p.is-small {
  font-size: .8em;
  margin-top: 12px;
}

ul {
  font-size: .9em;
}
.player-menu-open {
  position: fixed;
  width: auto;
  padding: 1.5em 1.5em 2.2em;
  min-width: 60vw;
  height: auto;
  top: 3.5rem;
  right: 1.8rem;
  left: 1.8rem;
  bottom: 6rem;
  background: linear-gradient(195deg, #fbfbfb 60%, #eee);
  z-index: 200;
  box-shadow: 1px 2px 8px rgba(0,0,0,.3);
  text-align: center;
  border-radius: 10px;
  overflow-y: auto;

  .title.is-4 {
    margin-bottom: 15px;
  }
}
</style>
